import React from 'react';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';

import {
  HotelHastagSection,
  HotelHastagContainer,
  HotelHastagHeading,
  HotelHastagSlider,
  HotelHastagSlide,
} from './styles';

const params = {
  slidesPerView: 'auto',
  spaceBetween: 1,
  freeMode: true,
};

const HotelHashtag = ({ hashtag }) => (
  <HotelHastagSection>
    <HotelHastagContainer>
      <HotelHastagHeading>{hashtag}</HotelHastagHeading>
      <HotelHastagSlider>
        <Swiper {...params}>
          {[0, 1, 2, 3].map(photo => (
            <HotelHastagSlide key={photo}>
              <img src="http://placehold.it/500x500" alt="" />
            </HotelHastagSlide>
          ))}
        </Swiper>
      </HotelHastagSlider>
    </HotelHastagContainer>
  </HotelHastagSection>
);

HotelHashtag.propTypes = {
  hashtag: PropTypes.string,
};

export default HotelHashtag;
